import { createORPCClient } from '@orpc/client'
import { RPCLink } from '@orpc/client/fetch'
import { createTanstackQueryUtils } from '@orpc/tanstack-query'

import type { RouterClient } from '@orpc/server'

import { getActiveBusinessId } from '@/hooks/useCurrentActiveBusiness'
import type { router } from '@repo/orpc/server'

const getORPCClient = (): RouterClient<typeof router> => {
  const link = new RPCLink({
    url: `${import.meta.env.VITE_API_URL || 'http://localhost:3000'}/rpc`,
    fetch: (request, init) => {
      const headers = request.headers
      headers.append('Business-Id', getActiveBusinessId()?.toString() ?? '')
      return globalThis.fetch(request, {
        ...init,
        headers,
        credentials: 'include',
      })
    },
  })
  return createORPCClient(link)
}

export const client: RouterClient<typeof router> = getORPCClient()

export const orpc = createTanstackQueryUtils(client)
